/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_FaqInputs */

const en_directory_ai_tools_eyebrow_faq = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

const zh_directory_ai_tools_eyebrow_faq = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`常见问题`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Directory_Ai_Tools_Eyebrow_FaqInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_faq = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_FaqInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_FaqInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_faq(inputs)
	return zh_directory_ai_tools_eyebrow_faq(inputs)
});
export { directory_ai_tools_eyebrow_faq as "directory.ai_tools.eyebrow.faq" }